import {
  BodyText,
  DetailText,
  Flex,
  Heading,
  Tab,
  TabContent,
  TabsList,
} from '@utilitywarehouse/hearth-react';
import SceneCashbackLight from '@utilitywarehouse/hearth-svg-assets/lib/scene-cashback-light.svg';

import { formatNumber } from '@utils/format';

import { useCashbackCalculatorContext } from '../CalculatorProvider/CalculatorContext';
import { Panel, PanelContent, PanelFooter, PanelHeading } from '../Panel/Panel';
import { EarnType } from '../types';
import { Categories } from './Categories/Categories';
import { OverTime } from './OverTime/OverTime';
import './styles.scss';

const Earn = () => {
  const { setCurrentEarnTab, currentEarnTab, currentSpendCalc, output } =
    useCashbackCalculatorContext();

  const {
    total: { earnings },
  } = output[currentSpendCalc];

  return (
    <Panel
      value={currentEarnTab}
      defaultValue="category"
      onValueChange={(value) => setCurrentEarnTab(value as EarnType)}
    >
      <PanelHeading>
        <Heading size="md" className="cbcCalculator__PanelHeading">
          How much could you earn?
        </Heading>
        {earnings > 0 && (
          <TabsList className="cbcCalculator__PanelTabs">
            <Tab value={EarnType.OverTime}>Over time</Tab>
            <Tab value={EarnType.Category}>By category</Tab>
          </TabsList>
        )}
      </PanelHeading>
      <PanelContent>
        {earnings === 0 && (
          <Flex
            justifyContent="center"
            alignItems="center"
            className="cbcCalculator__EarnEmpty"
            spacing="xl"
          >
            <img
              src={SceneCashbackLight}
              alt=""
              className="cbcCalculator__EarnEmptyIllustration"
            />
            <DetailText size="lg">Nothing to earn yet&hellip;</DetailText>
          </Flex>
        )}
        {earnings > 0 && (
          <>
            <TabContent value={EarnType.OverTime}>
              <OverTime earnings={earnings} />
            </TabContent>
            <TabContent value={EarnType.Category}>
              <Categories
                categories={output[currentSpendCalc].categories}
                earningsTotal={earnings}
              />
            </TabContent>
          </>
        )}
      </PanelContent>
      {earnings > 0 && (
        <PanelFooter>
          <>
            <BodyText size="lg" weight="semibold">
              Total monthly earnings
            </BodyText>
            <DetailText size="2xl">
              £
              {formatNumber(earnings, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </DetailText>
          </>
        </PanelFooter>
      )}
    </Panel>
  );
};

export { Earn };
